<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-4">
<p class="centerImage"><img alt="image" src="images/img9.jpg" style="max-width: 100%"/></p>
<p class="caption"><em class="italic">The church at Brading, perhaps the first Christian settlement in the Isle of Wight. The town itself was a busy port until land reclamation in the late seventeenth century. </em><span class="smallcaps">Carol Trow</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_ch14.vue?a5607304